import React, { useRef, useState } from "react";
import Header from "./Header/Header";
import Features from "./Features/Features";
import Images from "./Images/Images";
import Details from "./Details/Details";
import Recipes from "./Recipes/Recipes";
import DetailsOutstanding from "./Details/DetailsOutstanding";
import Recommendations from "./Recommendations/Recommendations";
import * as styles from "./ProductDetail.module.scss";
import Button from "../../UI/Button/Button";
import WhiteArrowRight from "../../../icons/arrows/white-right-arrow.svg";

const ProductDetail = ({ product, productRelated, recipeRelated }) => {
  const categoriesContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const onDragStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartX(e.clientX - categoriesContainerRef.current.offsetLeft);
    categoriesContainerRef.current.style.cursor = "grabbing";
  };

  const onDragEnd = () => {
    setIsDragging(false);
    categoriesContainerRef.current.style.cursor = "grab";
  };

  const onDragMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.clientX - categoriesContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1;
    categoriesContainerRef.current.scrollLeft -= walk;
    setStartX(x);
  };

  const colorCategory = product?.category_color;

  const handleKeyDown = (e) => {
    // Puedes personalizar esta función según las necesidades de tu componente
    switch (e.keyCode) {
      case 37: // Flecha izquierda
        // Código para desplazarse a la izquierda
        break;
      case 39: // Flecha derecha
        // Código para desplazarse a la derecha
        break;
      // Agrega casos adicionales para otras teclas si es necesario
      default:
        break;
    }
  };

  return (
    <div className="section">
      <Header
        name={product?.name}
        model={product?.product_code}
        colorCategory={colorCategory}
        link={product?.link_ecommerce}
      />
      <div className={styles.container_center_caracteristicas}>
        <div className={styles.center_caracteristicas}>
          <Images images={product?.images} colorCategory={colorCategory} videos={product?.videos}/>
          <Features
            characteristics={product?.features}
            colors={product?.available_variants}
            current={product?.slug}
            manual={product?.manual}
            recipesbook={product?.recipesbook}
            colorCategory={colorCategory}
            link={product?.link_ecommerce}
          />
        </div>
      </div>

      {product?.featured_features.length !== 0 ? (
        <div className={styles.container__destacado}>
          <DetailsOutstanding
            Outstanding={product?.featured_features}
            colorCategory={colorCategory}
            featured_image={product?.featured_image}
          />
        </div>
      ) : null}

      <div className={styles.container_details}>
        <Details details={product?.details} />
      </div>

      <div className={styles.contenRecetasRelacionadas}>
        {recipeRelated?.length !== 0 ? (
          <>
            <div className={styles.titleContent}>
              <div>
                <h4>Recetas</h4>
              </div>
              <a href="/recetas/">
                <Button
                  text="Ver más"
                  color={colorCategory}
                  icon={WhiteArrowRight}
                />
              </a>
            </div>

            {recipeRelated?.length !== 0 ? (
              <div
                className={styles.container_recipes}
                ref={categoriesContainerRef}
                onMouseDown={onDragStart}
                onMouseMove={isDragging ? onDragMove : null}
                onMouseUp={onDragEnd}
                onMouseLeave={onDragEnd}
                role="slider"
                tabIndex="0"
                onKeyDown={handleKeyDown}
                aria-valuenow={0}
              >
                <Recipes
                  colorCategory={colorCategory}
                  recipeRelated={recipeRelated}
                />
              </div>
            ) : null}
          </>
        ) : null}
      </div>

      <div className={styles.container_recommendations}>
        <Recommendations
          productRelated={productRelated}
          colorCategory={colorCategory}
        />
      </div>
    </div>
  );
};

export default ProductDetail;
